/**
 * Parent-brand endorsement, worded as in the Aunty Āwhi V6 guide ("Primary
 * Logo with Byline"). `onDark` swaps to the white lockup for Deep Green.
 */
export function KtomEndorsement({ onDark = false }: { onDark?: boolean }) {
  return (
    <div className="flex items-center gap-3">
      <img
        src={onDark ? '/ktom-lockup-white.png' : '/ktom-lockup.png'}
        alt="Ki tua o Matariki"
        className="h-8 w-auto shrink-0"
      />
      <p className={`text-xs ${onDark ? 'text-white/75' : 'text-inksoft'}`}>
        Aunty Āwhi is an initiative of Ki tua o Matariki
      </p>
    </div>
  )
}
